import { defineStore } from 'pinia'
import type { NuxtError } from '#app'

const ERROR_MSGS = {
  404: {
    ja: "ページが見つかりませんでした",
    en: "Page not Found",
  },
  500: {
    ja: "エラーが発生しました",
    en: "Unexpected error",
  },
  403: {
    ja: "権限をお持ちでないためこのページにアクセスすることが出来ません。",
    en: "You do not have permmision to access this page.",
  },
}

export interface ErrorState {
  statusCode?: number
  statusMsg?: string
  currentPath?: string
  targetPath?: string
}

export const useErrorStore = defineStore('error', () => {
  const error: Ref<ErrorState> = ref(null)
  const temp: Ref<ErrorState> = ref(null)

  const _setError = (
    statusCode: number,
    currentPath: string,
    targetPath: string,
  ) => {
    let errorMessage = ERROR_MSGS[statusCode]
    if (!errorMessage) {
      errorMessage = ERROR_MSGS[500]
    }
    const { ls } = useI18n()
    temp.value = {
      statusCode: statusCode,
      statusMsg: ls(errorMessage),
      currentPath: currentPath,
      targetPath: targetPath,
    }
  }

  const setDapError = (
    statusCode = 500,
    currentPath: string,
    targetPath: string,
    nuxtApp?,
  ): void => {
    // HTTPステータス・エラー情報の設定
    const event = nuxtApp ? useRequestEvent(nuxtApp) : useRequestEvent()
    setResponseStatus(event, statusCode)
    _setError(statusCode, currentPath, targetPath)
  }

  const createDapError = (): NuxtError => {
    if (!temp.value) {
      error.value = null
      return
    }
    error.value = temp.value
    //  エラーページを表示する。
    return createError({
      statusCode: error.value.statusCode,
      message: error.value.statusMsg,
      fatal: true,
    })
  }

  const getErrorTitle = (): string => {
    return `${getErrorStatusCode()}`
  }

  const getErrorStatusCode = (): number => {
    return error?.value?.statusCode
  }

  const getErrorMessage = (): string => {
    return error?.value?.statusMsg
  }

  const getErrorPath = (): string => {
    return error?.value?.targetPath
  }

  const hasCurrentError = (): boolean => {
    return temp.value !== null
  }

  const clearTemp = () => {
    temp.value = null
  }

  const clearDapError = async () => {
    await clearError()
    error.value = null
  }

  return {
    setDapError,
    createDapError,
    getErrorTitle,
    getErrorStatusCode,
    getErrorMessage,
    getErrorPath,
    hasCurrentError,
    clearTemp,
    clearDapError,
  }
})
